"use client";

import { useEffect, useState } from "react";
import TigerLoader from "@/components/TigerLoader";

export default function GlobalError({ error, reset }) {
  const [visible, setVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.error("App Error:", error);

    // Show TigerLoader briefly, then reveal error card
    const loaderTimer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);

    const visibleTimer = setTimeout(() => {
      setVisible(true);
    }, 1250); // slight delay after loader hides for smooth transition

    return () => {
      clearTimeout(loaderTimer);
      clearTimeout(visibleTimer);
    };
  }, [error]);

  if (isLoading) {
    return <TigerLoader />;
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .error-wrapper {
          position: relative;
          top: 20px;
          min-height: 100vh;
          display: flex;
          align-items: start;
          justify-content: center;
          font-family: 'Sora', sans-serif;
          padding: 24px;
        }

        .error-card {
          background: #ffffff;
          border-radius: 16px;
          padding: 25px 30px;
          max-width: 838px;
          width: 100%;
          box-shadow:
            0 1px 2px rgba(0,0,0,0.04),
            0 4px 16px rgba(0,0,0,0.06),
            0 12px 40px rgba(0,0,0,0.05);
          text-align: center;
          opacity: 0;
          transform: translateY(12px);
          transition: opacity 0.4s ease, transform 0.4s ease;
        }

        .error-card.visible {
          opacity: 1;
          transform: translateY(0);
        }

        .error-card p {
          font-size: 15px;
          line-height: 1.75;
          color: #5a5f6e;
          font-weight: 300;
          letter-spacing: 0.01em;
          margin-bottom: 28px;
        }

        .error-card p strong {
          color: #1a1d23;
          font-weight: 600;
        }

        .reload-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #1a1d23;
          color: #ffffff;
          border: none;
          border-radius: 8px;
          padding: 10px 20px;
          font-family: 'Sora', sans-serif;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.01em;
          cursor: pointer;
          transition: background 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease;
        }

        .reload-btn:hover {
          background: #2d3140;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(26,29,35,0.25);
        }

        .reload-btn:active {
          transform: translateY(0);
          box-shadow: none;
        }

        .reload-btn svg {
          width: 15px;
          height: 15px;
          flex-shrink: 0;
        }
      `}</style>

      <div className="error-wrapper">
        <div className={`error-card ${visible ? "visible" : ""}`}>
          <p>
            <strong>Connection Interrupted.</strong>{" "}
            It looks like a network hiccup stalled your request. Please check
            your internet connection and <strong>reload the page</strong> to try
            again. 🚨
          </p>

          <button onClick={() => reset()} className="reload-btn">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
              <path d="M3 3v5h5" />
            </svg>
            Reload Page
          </button>
        </div>
      </div>
    </>
  );
}
